"use client"

import { SWRConfig } from "swr"

type Props = {
  children: React.ReactNode;
}

export default function ProviderSWR({ children }: Props) {
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        shouldRetryOnError: false,
      }}
    >
      {children}
    </SWRConfig>
  )
}
